import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from 'file-saver';
import { sortBy } from 'lodash';
import * as moment from 'moment';
import { Modal } from 'ngx-modal/Modal';
import { NgProgress } from 'ngx-progressbar';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { DistributorIdFormatPipe } from '../../common/pipes/distributor-id-format.pipe';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { StoreConfig } from '../../shared/interface/StoreConfig.interface';
import { UserInfo } from '../../shared/interface/user-info.interface';
import { CacheService } from '../../shared/services/cache.service';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { IsoCodeThree, MemberType } from '../common/constants';
import { DraftEmailTicketConstants } from '../constants/draft-email-ticket.constants';
import { StatusConstants } from '../constants/status.constants';
import { Department } from '../enums/department-type.enum';
import { NotificationType } from '../enums/notification-types.enum';
import { TicketMessageType } from '../enums/ticket-message-type.enum';
import { Status } from '../enums/ticket-status.enum';
import { DisputeTypesEnums, SourceType } from '../enums/ticket-type.enum';
import { DepartmentUser } from '../interface/department-user.interface';
import { DraftEmailResponse } from '../interface/draft-email-response.interface';
import { EmailNotificationFlagIbfo } from '../interface/emailNotificationFlagInfo';
import { ProfileInformation } from '../interface/profile-info';
import { TagInputValue } from '../interface/tag-input-value.interface';
import { EmailAddress, MessageAttachment, TicketEmail } from '../interface/ticket-email.interface';
import { TicketHistoryResponse } from '../interface/ticket-history-response.interface';
import { TicketHistory } from '../interface/ticket-history.interface';
import { CreateTicketRequest } from '../interface/ticketingsystem/ticket-create';
import { TicketResponseModel } from '../interface/ticketingsystem/ticket-response.model';
import { DeleteModal } from '../models/delete-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { Utils } from '../../shared/Utils/utils';
import { DateConstants } from '../constants/date.constants';
import { TranslateParam } from '../../shared/interface/translate-param.interface';
import { MemberTypeEnum } from '../enums/member-type.enum';


declare var ClassicEditor: any;
@Component({
    selector: 'draft-email-ticket',
    templateUrl: '../templates/template1/views/draft-email-ticket.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/ticket.less',
        '../templates/template1/themes/default/css/draft-email-ticket.component.less'
    ],
    providers: [DistributorIdFormatPipe]
})

export class DraftEmailComponent implements OnInit {

    @ViewChild('forwardEmail') forwardEmailTicketPopup: Modal;
    @ViewChild('spamTicketConfirmationModal') spamTicketConfirmation: Modal;
    @ViewChild('AddNoteConfirmationModal') addNoteModal: Modal;
    @Input() distributorInfo: ProfileInformation;
    @Input() ticketingModel: TicketResponseModel;
    @Input() storeInfo: StoreConfig;
    @Input() tabIndex: number;
    @Input() isTeamTicket: boolean;
    @Input() isFormTicket: boolean;
    @Input() isFdTicket: boolean;

    draftEmailTicketForm: FormGroup;
    addNotesForm: FormGroup;
    bodyStr: string;
    message: string;
    isSubmitted: boolean;
    userInfo: UserInfo;
    showToAddressValidation = true;
    messageHistory: TicketHistory[];
    ticketHistoryContent = '';
    submitCompleted = false;
    uploader: any;
    attachmentsLength: number;
    attachments: MessageAttachment[] = [];
    ticektRequest: TicketEmail;
    showEmailErrorMessage: boolean;
    count = 0;
    showMaxFileSizeValidation = false;
    draftemailattachmentMaxSize: number = environment.draftEmailAttachmentsSize;
    ticketResponse: any;
    dueDateFormat: Date;
    dueDate: any; // we are getting Moment Object
    statuses: any[] = [];
    initialStatuses: any[] = [];
    statusId = 0;
    isTicketAssignPermission = true;
    permissionModal: DeleteModal;
    isTicketClosePermission: boolean;
    isTicketReopenPermission: boolean;
    emailAddress: EmailAddress[] = [];
    emailNotificationFlagIbfo: EmailNotificationFlagIbfo;
    users: DepartmentUser[];
    maxDescriptionChars = 20000;
    descriptionFocus = false;
    submitted = false;
    subjectMaxLength :any = {maxLength:500};
    uploadedImageUrlArr: any = [];
    uploadedImageLength: number = 0;
	assignedToId: number = 0;
    assignedToValue: string = "";
    isNotEligibleDept:boolean = true;
    showAssignCheckbox:boolean = false;
    emailSignatureResponse = [];
    signatureValue: any;
    translateParams: TranslateParam;
    memberTypeEnum = MemberTypeEnum;
    displaydropdown = false;
    enableFileUploadToPrivate: Boolean = environment.enableFileUploadToPrivate;

    momentConstructor: (value?: any) => moment.Moment = (<any>moment).default || moment;
    constructor(private _formbuilder: FormBuilder,
        private _customerservice: CustomerService,
        private _commonService: CommonService,
        private _cacheService: CacheService,
        private _messageService: MessageService,
        private _translatePipe: TranslateService,
        private distributorFormatPipe: DistributorIdFormatPipe,
        private ngProgress: NgProgress,
        private _datePipe: DatePipe) {

    }
    public _editor = ClassicEditor;

    public _config = {
        removePlugins: ['MediaEmbed', 'Title', 'ImageCaption'],
        toolbar: {
            items: [
                'heading',
                '|',
                'bold',
                'italic',
                'link',
                '|',
                'undo',
                'redo',
                '|',
                'imageUpload'
            ]
        },
        image:{
            toolbar: ['imageStyle:alignLeft'],
            styles: [
                'alignLeft'
            ]
        }
    };

    public emailValidators = [this.must_be_email];
    public errorMessages = DraftEmailTicketConstants.ERROR_MESSAGE;
    public splitPattern = new RegExp('[\;]');
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    ManageDepartmentPermissions: any[] = [
        Permission.MANAGE_DEPARTMENT_TICKETS_CLOSE,
        Permission.MANAGE_DEPARTMENT_TICKETS_RE_OPEN,
        Permission.MANAGE_DEPARTMENT_TICKETS_EDIT,
        Permission.MANAGE_DEPARTMENT_TICKETS_SELF_ASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_REASSIGN,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN
    ];
    private must_be_email(control: FormControl) {
        const EMAIL_REGEXP = DraftEmailTicketConstants.EMAIL_REGEXP;
        if (control.value.length !== '' && !EMAIL_REGEXP.test(control.value)) {
            return { 'must_be_email': true };
        }
        return null;
    }

    ngOnInit(): void {
        this.attachmentsLength = 0;
        this.uploader = this._customerservice.getFileUploader();
        this.uploader.onErrorItem = () => this.onErrorItem();
        this.uploader.onSuccessItem = (item: any, response: any, status: any, headers: any) => this.onSuccessItem(response);

        this.userInfo =  this._cacheService.get(CacheKey.UserInfo);
        this.getTicketStatuses();
        this.getUserPermission();
        this.getEmailSignature();
        this.permissionModal = new DeleteModal(this.cancel.bind(this),
                    this.cancel.bind(this), this.closePopUp.bind(this));
        this.permissionModal.viewActionButtons = false;
        this.getEmailNotificationFlagInfo(this.userInfo.userId, this.ticketingModel.id);
        if (this.ticketingModel.departmentId) {
            this.getDepartmentUsers(this.ticketingModel.departmentId);
        }

    }

    /**
     * @description
     * @date 2019-10-24
     * @private
     * @memberof DraftEmailComponent
     */
    private createDraftEmailTicketForm(): void {
        this.prepareEmailBodyContent();
        this.uploader.queue = [];
        this.draftEmailTicketForm = this._formbuilder.group({
            toAddress: [[], [Validators.required]],
            subject: [this.getTicketNumberWithSubject(),[Validators.maxLength(this.subjectMaxLength.maxLength)]],
            ccAddress: [[]],
            bccAddress: [[]],
            statusId: [this.ticketingModel.statusId ? this.ticketingModel.statusId : '', Validators.required],
			assignedToMyself: [],
            body: [this.bodyStr]
        });
        if (this.ticketingModel && (this.ticketingModel.sourceId === SourceType.Email || this.ticketingModel.sourceId === SourceType.Online_Form) && this.ticketingModel.sourceIdentifierValue)   {
            this.draftEmailTicketForm.controls['toAddress'].setValue([{
                display: this.ticketingModel.sourceIdentifierValue,
                value: this.ticketingModel.sourceIdentifierValue
            }]);
        } else if (this.distributorInfo && (this.distributorInfo.emailId || this.distributorInfo.email)) {
            this.draftEmailTicketForm.controls['toAddress'].setValue([{
                display: this.distributorInfo.emailId ? this.distributorInfo.emailId : this.distributorInfo.email,
                value: this.distributorInfo.emailId ? this.distributorInfo.emailId : this.distributorInfo.email
            }]);
        }
        if (this.ticketingModel && this.ticketingModel.statusId === Status.Closed) {
            this.draftEmailTicketForm.controls['statusId'].setValue(Status.InProgress);
        }
		if(this.isTicketAssignPermission){
            this.showAssignCheckbox = this.ticketingModel.assignedToId !==  this.userInfo.userId ? true : false;
            let user = this.users.find(item => item.id === +this.userInfo.userId);
            if(user) this.isNotEligibleDept = false;
            else this.isNotEligibleDept = true;
        }
    }

    /** Adding Focus to the Editor
     * @description
     * @date 2020-02-19
     * @memberof DraftEmailComponent
     */
    onForwardPopupOpen(): void {
        setTimeout(() => {
            const editor: any = document.querySelector('#ckeditor-js .ck-editor__editable');
            if (editor) {
                editor.ckeditorInstance.editing.view.focus();
            }
        }, 100);
    }
    /**
    *
    */
    private getTicketNumberWithSubject(): string {
        let ticketNumberWithSubject = '';
        if (this.messageHistory && this.messageHistory.length) {
            const message = this.messageHistory[0];
            ticketNumberWithSubject = message.subject;
        } else {
            ticketNumberWithSubject = this.ticketingModel.subject;
        }
        const hasTenDigitsRegex = new RegExp(/[0-9]{10}/g);
        const ticketNumberFromSubject = ticketNumberWithSubject.match(hasTenDigitsRegex);
        const ticketNumberExists = ticketNumberFromSubject && ticketNumberFromSubject.includes(this.ticketingModel.ticketNumber) ? true : false;
        if (!ticketNumberExists && ticketNumberWithSubject) {
            ticketNumberWithSubject = ticketNumberWithSubject + ' [Ticket Number: ' + this.ticketingModel.ticketNumber + ']'
        }
        return ticketNumberWithSubject;
    }

    private updateDraftEmailTicketForm(): void {
        this.draftEmailTicketForm.patchValue({
            subject: [this.getTicketNumberWithSubject()],
            ccAddress: [[]],
            bccAddress: [[]],
            body: [this.bodyStr]
        });
        if (this.distributorInfo && (this.distributorInfo.emailId || this.distributorInfo.email)) {
            this.draftEmailTicketForm.controls['toAddress'].setValue([{
                display: this.distributorInfo.emailId ? this.distributorInfo.emailId : this.distributorInfo.email,
                value: this.distributorInfo.emailId ? this.distributorInfo.emailId : this.distributorInfo.email
            }]);
        } else if (this.ticketingModel && (this.ticketingModel.sourceId === SourceType.Email || this.ticketingModel.sourceId === SourceType.Online_Form) && this.ticketingModel.sourceIdentifierValue) {
            this.draftEmailTicketForm.controls['toAddress'].setValue([{
                display: this.ticketingModel.sourceIdentifierValue,
                value: this.ticketingModel.sourceIdentifierValue
            }]);
        }
    }

    /**
     * Show modal pop-up
     */
    showDraftEmailPopup(): void {
        this.forwardEmailTicketPopup.closeOnOutsideClick = false;
        this.forwardEmailTicketPopup.closeOnEscape = false;
        if (this.draftEmailTicketForm) {
            this.updateDraftEmailTicketForm();
        } else {
            this.createDraftEmailTicketForm();
        }
        this.checkSubjectLength();
        this.forwardEmailTicketPopup.open();
    }
    /**
     * Binding email body
     */
    private prepareEmailBodyContent(): void {
       // const mailSignature: any = this._translatePipe.get('draftemailsignature');
        const countryCode = this.ticketingModel.departmentName.toLowerCase() === Department.SMILE_TEAM_360.toLowerCase() ?
            IsoCodeThree.USA : this.ticketingModel.operatingCountryCode;
            if(countryCode && this.emailSignatureResponse && this.emailSignatureResponse.length > 0) {
                this.signatureValue = this._customerservice.getSignatureValue(countryCode, this.emailSignatureResponse );
            }
        if((countryCode === IsoCodeThree.SWE || countryCode === IsoCodeThree.DEU || countryCode === IsoCodeThree.DEU || countryCode === IsoCodeThree.ARE) && this.ticketingModel.departmentEmail) {
            const parser = new DOMParser();
            const element = parser.parseFromString(this.signatureValue, 'text/html');
            const emailElement = element.querySelector('#emailId');
            emailElement.innerHTML = this.ticketingModel.departmentEmail;
            this.signatureValue= element.body.innerHTML;
        }

        let fboDetails = '';
        if (this.distributorInfo) {
            let fboId = this.distributorFormatPipe
                .transform((this.distributorInfo.distributorId ?
                    this.distributorInfo.distributorId : this.distributorInfo.fboId) || this.ticketingModel.memberId);
            fboId = (this.distributorInfo.memberType !== MemberType.GUEST ? (' | ' + fboId) : ' ');
            fboDetails = (this.distributorInfo.name ? this.distributorInfo.name
                : (this.distributorInfo.firstName + ' ' + this.distributorInfo.lastName))
                + fboId + (this.distributorInfo.memberType
                    ? (' | ' + (this.distributorInfo.level ? this.distributorInfo.level : this.distributorInfo.memberType)) : '');
        } else {
            fboDetails = 'NA';
        }
            this.bodyStr = `<div>
            <p></p><p></p>
            </div>
            <h4><strong>Ticket # ` + this.ticketingModel.ticketNumber + '</strong></h4>'
                + '<div class="emailbody"><strong>Member: </strong>'
                + fboDetails + '</div>'
                + '<div class="emailbody"><strong>Email: </strong>'
                + (this.distributorInfo && (this.distributorInfo.email || this.distributorInfo.emailId)
                    ? (this.distributorInfo.email ? this.distributorInfo.email : this.distributorInfo.emailId) : 'NA') + '</div>'
                + this.getWebOrderTag() + '<div id="emailsignature">' + this.signatureValue + '</div>'  + this.ticketHistoryContent;
            const styles = `<style>p,h1,h2,h3,h4{margin:0}</style>`;
            if (this.bodyStr.includes(styles)) {
                this.bodyStr = this.bodyStr.replace(styles, '');
            }
            if (this.bodyStr.includes('<style>')) {
                this.bodyStr = this.bodyStr.replace(/<style>(.|\n)*?<\/style>/g, '');
            } else if (this.bodyStr.includes('&lt;!--') && this.bodyStr.includes('--&gt;')) {
                this.bodyStr = this.bodyStr.replace(/&lt;!--(.|\n)*?--&gt;/, '');
            }
            this.bodyStr = this.bodyStr.replace(/<div[^>]*style="display:none[^>]*>(.|\n)*?<\/div>/, '');
            this.bodyStr = this.bodyStr.replace(/<span[^>]*style="display:none[^>]*>(.*?)<\/span>/, '');
            if (this.bodyStr.includes(`style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto"`)) {
                this.bodyStr = this.bodyStr.replace(/<p[^>]*style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto[^>](.*?)>/,`<p></p><p>`);
            }
    }

    /**
     * @description
     * @date 2019-11-05
     * @private
     * @returns {string}
     * @memberof DraftEmailComponent
     */
    private getWebOrderTag(): string {
        return (this.ticketingModel && this.ticketingModel.orderId) ? '<div class="emailbody"><strong>Web Order#: </strong>' +
            this.ticketingModel.orderId + '</div>' : '';
    }

    /**
     * after completing the image upload process
     * @param isValid
     * @param formValue
     */
    onSubmitComplete(isValid: boolean, formValue: any):void{
        this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
        this.draftEmailTicketForm.controls['body'].setValue(this.bodyStr);
        this.bodyStr = this.bodyStr.replace(/<p>&nbsp;<\/p>/gi, '');
        this.bodyStr = this.bodyStr.replace(/<h4>&nbsp;<\/h4>/gi, '');
        if (isValid && !this.submitCompleted) {
            this.ticektRequest = {
                to: this.mapTagInputValue(formValue.toAddress),
                cc: this.mapTagInputValue(formValue.ccAddress),
                bcc: this.mapTagInputValue(formValue.bccAddress),
                subject: this.mapSubjectValue(formValue.subject),
                mailBody: this.bodyStr,
                ticketId: this.ticketingModel.ticketNumber,
                parentTicketId: null,
                typeId: this.ticketingModel.typeId,
                attachments: null,
                operatingCountryId: this.ticketingModel.operatingCountryId,
                parentMessageId: this.messageHistory && this.messageHistory.length ? this.messageHistory[0].id : null
            };
            this.statusId = formValue.statusId;
			if(formValue.assignedToMyself){
                this.ticketingModel.assignedToId =  this.userInfo.userId;
                this.ticketingModel.assignedToValue = this.userInfo.userName;
                this.ticketingModel.isAssignedToMe = true;
                this.assignedToId = this.userInfo.userId;
            }
        }
        if (this.uploader.queue.length > 0) {
            this.uploadFile();
        } else {
            if (this.isTicketAssignPermission && +this.ticketingModel.assignedToId !== (this.userInfo.userId) &&
                (+this.statusId === this.ticketingModel.statusId ||
                    (+this.statusId !== Status.Closed &&  this.ticketingModel.statusId === Status.Closed && +this.statusId !== Status.InProgress ) ) ) {
                this.saveTicketEmail(this.ticektRequest);
            } else if (+this.statusId === Status.InProgress && this.ticketingModel.statusId === Status.Closed && !this.isTicketReopenPermission) {
                this.showHideForwardEmailPopup(false);
                this.displayAlertBoxOnNoPermissiononReopenTicket(true);
            } else if (+this.statusId === Status.Closed && !this.userInfo.hasSystemRole && !this.isTicketClosePermission)  {
                this.showHideForwardEmailPopup(false);
                this.displayAlertBoxOnNoPermissiononCloseTicket(true);
            } else {
                this.saveTicketEmail(this.ticektRequest);
            }
        }
    }
    mapSubjectValue(subject: any): string {
        if(Array.isArray(subject)) {
            if(subject && subject.length > 0 && subject[0]) {
                return subject[0];
            }
        }
        return subject;
    }
    /**
     * send button click
     */
    onSubmit(isValid: boolean, formValue: any): void {
       this.getCkeditorData(isValid, formValue);
    }
    /**
     * @description Will get the data from ckEditorInstance
     * @date 2020-05-20
     * @memberof DraftEmailComponent
     */
    getCkeditorData(isValid: boolean, formValue: any) {
        const editor: any = document.querySelector('#ckeditor-js .ck-editor__editable');
        this.uploadedImageLength = 0;
        this.uploadedImageUrlArr = [];
        if(editor){
            let contentDiv = document.querySelector('#ckeditor-content');
            contentDiv.innerHTML = (editor.ckeditorInstance.getData());
            let elements: any = document.querySelectorAll('#ckeditor-content > figure');
            if(elements){
                elements.forEach(element => {
                    if(element && element.nodeName === 'FIGURE'){
                        if(element && element.attributes && element.attributes.style && element.attributes.style.value){
                            let width = element.attributes.style.value.replace('width:','');
                            if(element.firstChild && element.firstChild.nodeName === 'IMG'){
                                element.firstChild.setAttribute('width', width);
                                element.removeAttribute('style');
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0){
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                        else{
                            if(element && element.firstChild && element.firstChild.nodeName === 'IMG'){
                                if (element.firstChild.attributes.src.value.split(',')[0].indexOf('base64') >= 0){
                                    this.dataURItoBlob(isValid, formValue, element);
                                    this.uploadedImageLength++;
                                }
                            }
                        }
                    }
                });
            }
            this.bodyStr = document.querySelector('#ckeditor-content').innerHTML;
            this.draftEmailTicketForm.controls['body'].setValue(this.bodyStr);
        }
        if(this.uploadedImageLength === 0){
            this.onSubmitComplete(isValid, formValue);
        }
    }

    dataURItoBlob(isValid: boolean, formValue: any, element: any) {
        let byteString;
        let fileName = 'image_' + Date.now();
        let dataURI = element.firstChild.attributes.src.value;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = decodeURI(dataURI.split(',')[1]);

        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        let ia = new Uint8Array(byteString.length);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        let blob = new Blob([ia], {type:mimeString});
        var formData: any = new FormData(document.forms[0]);

        const file = new File([blob], fileName);
        formData.append("file", file);
        formData.append("fileName", fileName);
        formData.append("path", 'content/customer-service/' + this.ticketingModel.operatingCountryId + '/images/');
        this._customerservice.uploadImageFile(formData)
            .subscribe((response: any) => {
                if (response) {
                    element.firstChild.attributes.src.value = response.signedUrl;
                    this.uploadedImageUrlArr.push(response.key);
                    if(this.uploadedImageLength === this.uploadedImageUrlArr.length){
                        this.onSubmitComplete(isValid, formValue);
                    }
                }
            });
    }

    /** *  UPLOAD FILE   ----- BEGIN ----- ************************* */
    /**
     * Upload file
     */
    uploadFile() {
        if (this.uploader && this.uploader.queue.length > 0) {
            this.ngProgress.start();
            let filelength = 0;
            const ticketNumber = this.ticketingModel.id;
            this.uploader.onBuildItemForm = (item: any, form: any) => {
                filelength++;
                item.withCredentials = false;
                item.uploader.authToken = this._customerservice.getAuthorizationToken();
                const fileNameArr = item.file.name.split('.');
                const filename = fileNameArr[0].replace(/[&\/\\#,+()$~%'":*?@!$^*;<>{}/ +(?= )]/g, '');
                item.file.name = filename + '_' + ticketNumber + '_' + filelength
                    + (fileNameArr.length > 1 ? '.' + fileNameArr[fileNameArr.length - 1] : '');
                form.append('fileName', decodeURIComponent(encodeURIComponent(item.file.name)));
                form.append('path', 'content/customer-service/' + this.ticketingModel.operatingCountryId + '/');
            };
            for (let i = 0; i < this.uploader.queue.length; i++) {
                this.uploader.queue[i].upload();
            }
        }
    }
    /**
     * check maximum Attachments
     */
    validateMessageAttachments(): void {
        if (this.uploader.queue) {
            let totalSize = 0;
            let messageAttachmentSize = 0;
            this.uploader.queue.forEach(item => {
                messageAttachmentSize = messageAttachmentSize + item.file.size;
            });
            totalSize = +(messageAttachmentSize / 1024 / 1024).toFixed(2);
            this.attachmentsLength = this.uploader.queue.length;
            if (totalSize > environment.draftEmailAttachmentsSize) {
                this.uploader.queue[this.uploader.queue.length - 1].remove();
                this.attachmentsLength--;
                this.showMaxFileSizeValidation = true;
                setTimeout(() => {
                    this.showMaxFileSizeValidation = false;
                }, 2000);
            }
            if (this.attachmentsLength >= 5) {
                while (this.attachmentsLength > 5) {
                    this.uploader.queue[this.uploader.queue.length - 1].remove();
                    this.attachmentsLength--;
                }
            }
        }
    }

    removeSize() {
        this.validateMessageAttachments();
    }
    /**
    * failed to upload file
    * @param item
    * @param response
    * @param status
    * @param headers
    */
    onErrorItem(): any {
        this.ngProgress.done();
        this._commonService.createNotification('', 'Failed to upload document. Please try after sometime ', NotificationType.ERROR);
    }
    /**
    * On Successful upload of file
    * @param item
    * @param response
    * @param status
    * @param headers
    */
    onSuccessItem(response: string): any {
        if (response) {
            const res = JSON.parse(response);
            const fileDetails = {
                'ticketId': this.ticketingModel.id,
                'fileName': this.uploader.queue[this.count].file.name.substr(0, 95),
                'url': res.url,
                'eTag': res.eTag,
                'key': res.key
            };
            this.attachments.push(fileDetails);
            this.count++;
            if (this.uploader.queue.length === this.count) {
                this.sendEmailMessage();
            }
        } else {
            this._commonService.createNotification('', 'File Not uploaded', NotificationType.ERROR);
        }
        this.ngProgress.done();
    }

    /**
     * send Email Message
     */
    sendEmailMessage(): void {
        this.ticektRequest.attachments = this.attachments;
        this.saveTicketEmail(this.ticektRequest);
    }
    getUserPermission() {
        if (!this.userInfo.hasSystemRole) {
            this.isTicketClosePermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[0] + ']'), AccessLevel.Customer_Service);
            this.isTicketReopenPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.ManageDepartmentPermissions[1] + ']'), AccessLevel.Department, this.ticketingModel.departmentId);
            this.isTicketAssignPermission = this._commonService.checkPermissionByAccessLevel(JSON.parse('[' + this.FBOManageTicketPermissions[0] + ']'), AccessLevel.Customer_Service);
        } else {
            this.isTicketClosePermission = true;
            this.isTicketReopenPermission = true;
            this.isTicketAssignPermission = true;
        }
    }

    /**
     * @description
     * @date 2019-10-21
     * @private
     * @returns {string[]}
     * @memberof DraftEmailComponent
     */
    private mapTagInputValue(tagInputValue: TagInputValue[]): string[] {
        if (tagInputValue && tagInputValue.length > 0) {
                    return tagInputValue.map(x => {
                        return x['value'];
                  });
                }
            }
    closeTab() {
        const tabinfo = new TicketTabInfo();
        tabinfo.ticketID = this.ticketingModel.id;
        tabinfo.ticketNumber = this.ticketingModel.ticketNumber;
        tabinfo.distributorID = this.distributorInfo ? this.distributorInfo.distributorId : null;
        tabinfo.tabIndex = this.tabIndex;
        tabinfo.isTeamTicket = this.isTeamTicket ? this.isTeamTicket : false;
        tabinfo.isFormTicket = this.isFormTicket ? this.isFormTicket : false;
        tabinfo.isFdTicket = this.isFdTicket ? this.isFdTicket : false;
        this._messageService.setClosingTabInfo(tabinfo);
    }
    /**
     * creating draft email ticket
     */
    saveTicketEmail(ticketEmail: TicketEmail): void {
        this.submitCompleted = true;
        ticketEmail.mailBody = ticketEmail.mailBody.replace(/<h4><strong>History(.*?)<\/h4>/gi, '');
        ticketEmail.mailBody = ticketEmail.mailBody.replace(/<p><br data-cke-filler="true">(.*?)<\/p>/gi, '');
        ticketEmail.mailBody = ticketEmail.mailBody.replace(/<h4><br data-cke-filler="true">(.*?)<\/h4>/gi, '');
        this._customerservice.updateDraftEmail(ticketEmail)
            .subscribe((response: DraftEmailResponse) => {
                if (response && response.success) {
                    this.forwardEmailTicketPopup.close();
                    this._messageService.setDraftEmailsaved(true);
                    this.count = 0;
                    this.message = 'Email sent sucessfully.';
                    const isDistributeTicket = this._cacheService.get(CacheKey.IsDistributeTicket);
                    this.updateTicket(isDistributeTicket);
                    this._commonService.createNotification('', this.message, NotificationType.SUCCESS);
                    this.isSubmitted = false;
                    this.closeTab();
                } else if (response && response.validations.length > 0) {
                    this.message = response.validations[0].message;
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                    this.count = 0;
                    this.ticektRequest.attachments = [];
                    this.attachments = [];
                } else {
                    this.message = 'Email sent failed.';
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                    this.count = 0;
                    this.ticektRequest.attachments = [];
                    this.attachments = [];
                }
                this.submitCompleted = false;
            }, error => {
                if (error && !error.success && error.validations && error.validations.length > 0) {
                    this.message = error.validations[0].message;
                    this.count = 0;
                    this.ticektRequest.attachments = [];
                    this.attachments = [];
                    this.showEmailErrorMessage = true;
                    setTimeout(() => {
                        this.showEmailErrorMessage = false;
                    }, 7000);
                } else if (error) {
                    this.message = 'Email sent failed.';
                    this._commonService.createNotification('', this.message, NotificationType.ERROR);
                }
            });
    }

    /**
     * @description Updating the ticket after sending an Outbound Email
     * @param isDistributeTicket
     */
    updateTicket(isDistributeTicket: boolean): void {
        const ticket = new CreateTicketRequest();
        let fboId: string;
        if (this.ticketingModel.memberId) {
            fboId = this.ticketingModel.memberId;
            fboId = fboId.replace(/-|\s/g, '');
            ticket.memberId = fboId;

        } else {
            ticket.memberId = null;
        }
        ticket.sourceId = this.ticketingModel.sourceId;
        ticket.operatingCountryId = this.ticketingModel.operatingCountryId;
        ticket.countryId = this.ticketingModel.countryId;
        ticket.typeId = this.ticketingModel.typeId;
        ticket.attachments = this.ticketingModel.attachments;
        ticket.subTypeId = this.ticketingModel.subTypeId;
        ticket.description = this.ticketingModel.description;
        ticket.ticketNumber = this.ticketingModel.ticketNumber;
        ticket.priorityId = this.ticketingModel.priorityId;
        if (this.ticketingModel.dueDate) {
            this.dueDateFormat = new Date(this.ticketingModel.dueDate);
            this.dueDate = this.momentConstructor(this.ticketingModel.dueDate);
        }
        ticket.dueDate = this.ticketingModel.dueDate ? Utils.convertToSpecificDateFormat(this.dueDate, DateConstants.DOBFormat) : null;
        ticket.assignedToId = this.ticketingModel.assignedToId;
        ticket.operatingCountryId = this.ticketingModel.operatingCountryId;
        ticket.departmentId = this.ticketingModel.departmentId;
        ticket.attachments = this.ticketingModel.attachments;
        ticket.subject = this.ticketingModel.subject;
        ticket.callerName = this.ticketingModel.callerName;
        ticket.sourceIdentifierValue = this.ticketingModel.sourceIdentifierValue;
        ticket.distributorName = ticket.memberId ? this.distributorInfo.name : null;
        ticket.agentEmail = this.userInfo.email;
        ticket.agentName = this.userInfo.firstName + ' ' + this.userInfo.lastName;
        ticket.ticketLink = window.location.href;
        ticket.userId = this.userInfo.userId;
        ticket.firstName = this.userInfo.firstName;
        ticket.lastName = this.userInfo.lastName;
        ticket.statusId = this.statusId ? +this.statusId : this.ticketingModel.statusId;
        ticket.id = this.ticketingModel.id;
        ticket.createdBy = this.ticketingModel.createdBy;
        ticket.updatedBy = this.userInfo.userId;
        if (this.ticketingModel.orderId) {
        ticket.orderId = this.ticketingModel.orderId;
        }
        if (isDistributeTicket) {
            if (+this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
                ticket.disputes = this.ticketingModel.disputes;
            }
            ticket.orderReasonNotes = this.ticketingModel.orderReasonNotes;
        }
        if (this.ticketingModel.notes) {
            this.ticketingModel.notes.forEach(note => {
                note.createdDate = Utils.convertToSpecificDateFormat(this.momentConstructor(new Date(note.createdDate)), DateConstants.DOBFormat);
            });
        }
        ticket.notes = this.ticketingModel.notes;
        ticket.copyToUsers = this.ticketingModel.copyToUsers;
        ticket.assignedToEmail = this.ticketingModel.assignedToEmail;
        if (+this.statusId  === Status.Closed) {
            ticket.closeReasonId = DraftEmailTicketConstants.RESOLVED.id;
            ticket.closeReason = DraftEmailTicketConstants.RESOLVED.value;
        }
        this._customerservice.updateTicketById(this.ticketingModel.id, ticket)
            .subscribe((response: TicketResponseModel) => {
                if (response) {
                    this.ticketResponse = response;
                    this._messageService.setAuditLogUpdated(true);
                    const addedNotification: any = this._translatePipe.get('Ticket ' + this.ticketResponse.ticketNumber + ' has been Updated successfully');
                    this._commonService.createNotification('', addedNotification.value , NotificationType.SUCCESS);
                }
            });
    }


    /**
    * closing modal pop-up
    */
    closePopUpforDraftEmailChange(): void {
        this.forwardEmailTicketPopup.close();
        this.draftEmailTicketForm = null;
    }
    /**
     * @description On text Changes for to Address
     * @date 2019-10-22
     * @param {string} value
     * @memberof DraftEmailComponent
     */
    onTagsChange(value: string): void {
        if (value && !this.draftEmailTicketForm.controls['toAddress'].value.length) {
            this.showToAddressValidation = false;
        } else {
            this.showToAddressValidation = true;
        }
    }

    actionOnClose(): void {
        this.draftEmailTicketForm = null;
    }

    /**
     * @description to get ticket history
     * @date 2019-10-31
     * @param {string} value
     * @memberof DraftEmailComponent
     */
    getTicketHistory(): void {
        this.uploader.queue = [];
        this.attachmentsLength = 0;
        this._customerservice.getTicketHistory(this.ticketingModel.id).subscribe((response: TicketHistoryResponse) => {
            if (response && response.success && response.messages && response.messages.length) {
                this.messageHistory = response.messages;
                this.prepareEmailHistory();
            }
            this.showDraftEmailPopup();
        }, error => {
            this.showDraftEmailPopup();
        });
    }

    /**
     * @description to prepare ticket history and append to body
     * @date 2019-10-31
     * @param {string} value
     * @memberof DraftEmailComponent
     */
    prepareEmailHistory(): void {
        let messageHistory = '';
        const history = this.messageHistory[0];
        const sent = this._datePipe.transform(new Date(), 'EEEE, dd-MMM-yy h:mm');
        messageHistory = messageHistory + '<h4><strong>History</strong></h4>'
            + '<p><strong>________________________________________________________________________________________'
            + '__________________________________________________</strong></p><p>From: ' + history.from
            + '</p><p>Sent: ' + sent + '</p><p>To: ' + history.to.join(', ') + '</p>'
            + this.getCCEmailHistory(history) + '<p>Subject: ' + history.subject
            + '</p>' + this.checkEmailSignatureSpacing (history.mailBody) +history.mailBody;
        this.ticketHistoryContent = messageHistory;
    }

    /**
     * get cc email content in email body
     */
    private getCCEmailHistory(history: TicketHistory): string {
        return (history && history.cc && history.cc.length > 0) ? '<p>CC: ' + history.cc.join(', ') + '</p>' : '';
    }
    /**
     *
     * @param url
     * @param fileName
     */
    downloadDocument(url: string, fileName: string) {
      if (this.enableFileUploadToPrivate) {
        let path = new URL(url).pathname.slice(1);
        let s3Path = path.slice(0, path.lastIndexOf("/") + 1);
        this._customerservice.downloadFile(s3Path, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          const downloadNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downloadNotification.value, NotificationType.SUCCESS);
        }, err => {
          let downloadNotification: any = this._translatePipe.get("Something Went Wrong, Please try again after some time");
          this._commonService.createNotification("", downloadNotification.value, NotificationType.ERROR);
        });
      } else {
        this._customerservice.downloadDocument(url, fileName).subscribe(blob => {
          importedSaveAs(blob, fileName);
          let downlaodNotification: any = this._translatePipe.get('Attachment  has been downloaded successfully');
          this._commonService.createNotification('', downlaodNotification.value, NotificationType.SUCCESS);
        });
      }
    }
    /**
     * get ticket status for populating to dropdown
     */
    getTicketStatuses() {
        this._customerservice.getTicketStatus().subscribe((response) => {
            if (response) {
                this.initialStatuses = response;
                if (this.ticketingModel.statusId === Status.Closed) {
                    this.initialStatuses.forEach((status: any) => { if (status.id === Status.InProgress) { status.value = StatusConstants.Reopen } })
                    this.statuses = this.initialStatuses;
                } else {
                    this.statuses = this.initialStatuses;
                }
                this.statuses = sortBy(this.statuses, 'value');
            }
        });
    }

    displayAlertBoxOnNoPermissiononCloseTicket(hasPermission: Boolean) {
        this.permissionModal.toggle = true;
        if (hasPermission) {
            this.permissionModal.message = CommonMessage.noPermissionToCloseMessage;
        } else {
            this.permissionModal.message = CommonMessage.noCloseTicketPermissionMessage;
        }

    }
    displayAlertBoxOnNoPermissiononReopenTicket(hasPermission: Boolean) {
        this.permissionModal.toggle = true;
        if (hasPermission) {
            this.permissionModal.message = CommonMessage.noPermissionToReOpenMessage;
        } else {
            this.permissionModal.message = CommonMessage.noReopenTicketPermissionMessage;
        }
    }
    showHideForwardEmailPopup(isOpen: boolean) {
        if (isOpen) {
            this.populateDraftEmailTicketForm();
            this.checkSubjectLength();
            this.forwardEmailTicketPopup.open();
        } else {
            this.forwardEmailTicketPopup.close();
        }
    }
    populateDraftEmailTicketForm() {
        this.draftEmailTicketForm = this._formbuilder.group({
            toAddress: [[], [Validators.required]],
            subject: [this.ticektRequest.subject,[Validators.maxLength(this.subjectMaxLength.maxLength)]],
            ccAddress: [[]],
            bccAddress: [[]],
            statusId: [this.statusId],
			assignToMe: [],
            body: [this.ticektRequest.mailBody]
        });
        if (this.ticektRequest.to) {
            this.emailAddress = [];
            this.ticektRequest.to.forEach(toAddress => {
                this.emailAddress.push({
                    display: toAddress,
                    value: toAddress
                });
            });
            this.draftEmailTicketForm.controls['toAddress'].setValue(this.emailAddress);
        }
        if (this.ticektRequest.cc) {
            this.emailAddress = [];
            this.ticektRequest.cc.forEach(ccAddress => {
                this.emailAddress.push({
                    display: ccAddress,
                    value: ccAddress
                });
            });
            this.draftEmailTicketForm.controls['ccAddress'].setValue(this.emailAddress);
        }
        if (this.ticektRequest.bcc) {
            this.emailAddress = [];
            this.ticektRequest.bcc.forEach(bccAddress => {
                this.emailAddress.push({
                    display: bccAddress,
                    value: bccAddress
                });
            });
            this.draftEmailTicketForm.controls['bccAddress'].setValue(this.emailAddress);
        }
    }
    cancel() {
        // data should not be removed...
    }
    closePopUp() {
        this.showHideForwardEmailPopup(true);
    }

    markTicketAsSpam() {
        const ticketToBeSpamed = [];
        const isSpam = true;
        const spamOrUnspamReason: any = this._translatePipe.get('validation-message.Ticket is marked as unspam');
        ticketToBeSpamed.push({id: this.ticketingModel.id, ticketNumber: this.ticketingModel.ticketNumber, updatedBy: this.userInfo.userId, closeOtherReason: spamOrUnspamReason.value});
        this._customerservice.markATicketorAllTicketsAsSpamOrUnpsam(ticketToBeSpamed, isSpam).subscribe(response => {
            if (response) {
                const success: any = this._translatePipe.get('success-message.Ticket is marked as spam and closed successfully');
                this._commonService.createNotification('', success.value , NotificationType.SUCCESS);
                this.closeTab();
            } else {
                const failed: any = this._translatePipe.get('error-message.Ticket could not be marked as spam');
                this._commonService.createNotification('', failed.value, NotificationType.ERROR);
            }
        }, error => {
            const unknown: any = this._translatePipe.get('validation-message.Unknown Error');
            this.message = (error != null && error[0] != null) ? error[0].field + ' : ' + error[0].message : unknown.value;
            this._commonService.createNotification('', this.message, NotificationType.ERROR);
        });
        this.closeSpamTicketConfirmationPopup();
    }

    saveNotes(): void {
        this.submitted = true;
        if (this.addNotesForm.valid) {
            const ticketRequest = this.prepareSaveTicketRequest();
            this.saveTicketNote(ticketRequest);
        }
    }

    prepareSaveTicketRequest(): CreateTicketRequest {
        let ticket: CreateTicketRequest = new CreateTicketRequest();
        let fboId: string;
        if (this.ticketingModel.memberId) {
            fboId = this.ticketingModel.memberId;
            fboId = fboId.replace(/-|\s/g, '');
           ticket.memberId = fboId;
        } else {
            ticket.memberId = null;
            ticket.memberType = null;
        }
        ticket.sourceId = this.ticketingModel.sourceId;
        ticket.operatingCountryId = this.ticketingModel.operatingCountryId;
        ticket.typeId = this.ticketingModel.typeId;
        ticket.attachments = this.ticketingModel.attachments;
        ticket.subTypeId = this.ticketingModel.subTypeId;
        ticket.description = this.ticketingModel.description;
        ticket.departmentId = this.ticketingModel.departmentId;
        ticket.ticketNumber = this.ticketingModel.ticketNumber;
        ticket.priorityId = this.ticketingModel.priorityId;
        if (this.ticketingModel.dueDate) {
            this.dueDateFormat = new Date(this.ticketingModel.dueDate);
            this.dueDate = this.momentConstructor(this.ticketingModel.dueDate);
        }
        ticket.dueDate = this.ticketingModel.dueDate ? Utils.convertToSpecificDateFormat(this.dueDate, DateConstants.DOBFormat) : null;
        ticket.subject = this.ticketingModel.subject;
        ticket.assignedToId = this.ticketingModel.assignedToId;
        ticket.callerName = this.ticketingModel.callerName;
        ticket.sourceIdentifierValue = this.ticketingModel.sourceIdentifierValue;
        ticket.distributorName = ticket.memberId ? this.distributorInfo.name : null;
        ticket.agentEmail = this.userInfo.email;
        ticket.agentName = this.userInfo.firstName + ' ' + this.userInfo.lastName;
        ticket.ticketLink = window.location.href;
        ticket.countryId = this.ticketingModel.countryId;
        if (this.users && this.ticketingModel.assignedToId) {
            const assignedToUser = this.users.find(item => item.id === +this.ticketingModel.assignedToId);
            if (assignedToUser) {
                ticket.assignedToEmail = assignedToUser.email;
            }
        } else {
            ticket.assignedToEmail = this.ticketingModel.assignedToEmail;
        }

        const distributorInfo = (fboId && this.distributorInfo && this.distributorInfo.memberType)
            ? this.distributorInfo : (fboId && this.distributorInfo ? this.distributorInfo : null);
        if (distributorInfo) {
            if (distributorInfo.memberType === MemberType.RETAIL || distributorInfo.memberType === MemberType.RETAIL_CUSTOMER
                || distributorInfo.memberType === MemberType.RETAILCUSTOMER) {
                    ticket.memberType = MemberType.RETAIL;
            } else if (distributorInfo.memberType === MemberType.GUEST || distributorInfo.memberType === 'G') {
                ticket.memberType = MemberType.GUEST;
            } else if (distributorInfo.memberType === MemberType.FPC) {
                ticket.memberType = MemberType.FPC;
            } else {
                ticket.memberType = MemberType.FOB;
            }
        }
        ticket.sendMailNotification = this.addNotesForm.value.sendMailNotification;
        ticket.userId = this.userInfo.userId;
        ticket.firstName = this.userInfo.firstName;
        ticket.lastName = this.userInfo.lastName;
        ticket.statusId = this.addNotesForm.value.statusId;
        ticket.note = this.addNotesForm.value.notes;
        ticket.id = this.ticketingModel.id;
        ticket.createdBy = this.ticketingModel.createdBy;
        ticket.updatedBy = this.userInfo.userId;
        ticket.copyToUsers = (this.ticketingModel.copyToUsers && this.ticketingModel.copyToUsers.length > 0) ?
             this.ticketingModel.copyToUsers : [];
        if (this.ticketingModel.locationTypeId) {
            ticket.locationTypeId = this.ticketingModel.locationTypeId;
        }
        if (this.ticketingModel.orderId) {
            ticket.orderId = this.ticketingModel.orderId;
        }
        if (+this.ticketingModel.disputeTypeId === DisputeTypesEnums.Dispute_Individual_Order) {
            ticket.disputes = this.ticketingModel.disputes;
        }
        if (this.ticketingModel.orderReasonNotes) {
            ticket.orderReasonNotes = this.ticketingModel.orderReasonNotes;
        }
        return ticket;
    }

    saveTicketNote(ticketRequest: CreateTicketRequest) {
        this._customerservice.updateTicketById(this.ticketingModel.id , ticketRequest).subscribe(response => {
            if (response) {
                this.isSubmitted = false;
                this.ticketResponse = response;
                const addedNotification: any = this._translatePipe
                .get('Ticket ' + this.ticketResponse.ticketNumber + ' has been Updated successfully');
                this._commonService.createNotification('', addedNotification.value , NotificationType.SUCCESS);
                this.closeAddNoteConfirmationPopup();
                this.closeTab();
            }
        });
    }

    getDepartmentUsers(departmentId: number): void {
        this._customerservice.getAssignedUsersByDepartments(departmentId).subscribe(response => {
            if (response) {
                this.users = response;
                if (this.users && this.users.length > 0) {
                    this.users = this.users.sort(function (a, b) {
                        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
                    });
                    let user = this.users.find(item => item.id === +this.userInfo.userId);
                        if(user) this.isNotEligibleDept = false;
                        else this.isNotEligibleDept = true;
                }
               this.displaydropdown= true;
            } else {
                this.users = [];
                this.displaydropdown= true;
            }
        });
    }

    /**
     * @description
     * @date 2020-04-03
     * @param {number} userId
     * @param {number} ticketID
     * @memberof DraftEmailComponent
     */
    getEmailNotificationFlagInfo(userId: number, ticketID: number) {
        this._customerservice.getEmailNotificationFlagIbfo(userId, ticketID).subscribe((response) => {
            if (response) {
                this.emailNotificationFlagIbfo = response;
                this.emailNotificationFlagIbfo.ticketNumber = ticketID.toString();
            }
        });
    }

    closeSpamTicketConfirmationPopup() {
        this.spamTicketConfirmation.close();
    }

    openSpamTicketConfirmationPopup() {
        this.spamTicketConfirmation.open();
    }

    closeAddNoteConfirmationPopup() {
        this.submitted = false;
        this.addNoteModal.close();
    }

    openAddNoteConfirmationPopup() {
        this.addNotesForm = this._formbuilder.group(
        {
             notes: ['', Validators.required],
             sendMailNotification: [ this.emailNotificationFlagIbfo ? this.emailNotificationFlagIbfo.sendMailNotification : false],
             statusId: [this.ticketingModel.statusId ? this.ticketingModel.statusId : '', Validators.required],

        });
        if (this.ticketingModel.statusId === Status.Closed) {
            this.addNotesForm.controls['statusId'].setValue(Status.InProgress);
        }
        this.addNoteModal.open();
    }

    checkSubjectLength(): void {
        if(this.draftEmailTicketForm.value && this.draftEmailTicketForm.value.subject && this.subjectMaxLength) {
            if (this.draftEmailTicketForm.value.subject.length > this.subjectMaxLength.maxLength) {
                this.draftEmailTicketForm.controls['subject'].markAsTouched();
            }
        }
    }
    checkEmailSignatureSpacing(content: string): string {
        if (content.includes(`style="mso-margin-top-alt:auto;mso-margin-bottom-alt:auto"`)) {
            return '<p></p>';
        } else {
            return '';
        }
    }


    /**
     * @description To get email siganture for operating countries
     * @returns void
    */

    getEmailSignature(): void {
        this._customerservice.getEmailSignatures().subscribe(res =>{
            if(res && res.length > 0) {
                this.emailSignatureResponse  = res;
            }
            else {
                this.emailSignatureResponse = [];
            }
        },(error) => {
            this.emailSignatureResponse = [];
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/draft-email-ticket.component.ts